import { notify } from '@kyvg/vue3-notification';

import { notificationErrorText } from '@/utils/PortalConstants';

interface NotifyOptions {
  group?: string;
  title?: string;
  text?: string;
  type?: string;
  duration?: number;
}

const paramsDefault = {
  group: 'defaultNotificationHolder',
  title: '',
  text: notificationErrorText,
  type: 'warning',
  duration: -1,
};

export function showNotification(notifyOptions: NotifyOptions): void {
  notify({ ...paramsDefault, ...notifyOptions });
}

export function showWarningNotification(notifyOptions: NotifyOptions): void {
  notify({ ...paramsDefault, ...notifyOptions, type: 'warning' });
}

export function showErrorNotification(notifyOptions: NotifyOptions): void {
  notify({ ...paramsDefault, ...notifyOptions, type: 'error' });
}

export function showSuccessNotification(notifyOptions: NotifyOptions): void {
  notify({ ...paramsDefault, ...notifyOptions, type: 'success' });
}

const trackingRefreshNotificationId = 1;
const portalOutdatedNotificationId = 2;

export function closeTrackingRefreshNotification(): void {
  notify.close(trackingRefreshNotificationId);
}

export function showTrackingRefreshNotification(
  refreshDashboardJobs: () => void,
): void {
  const newParams = {
    ...paramsDefault,
    type: 'warning',
    title: 'The data is outdated',
    data: {
      close: refreshDashboardJobs,
      dangerouslySetInnerHtmlText:
        'Click to refresh the data <i class="mdi-autorenew mdi v-icon text-lg ml-1"></i>',
    },
    id: trackingRefreshNotificationId,
  };
  notify(newParams);
}

export function showPortalOutdatedNotification(): void {
  const newParams = {
    ...paramsDefault,
    type: 'warning',
    title: 'The portal version is outdated',
    data: {
      close: () => {
        window.location.reload();
      },
      dangerouslySetInnerHtmlText:
        'Click to refresh the page <i class="mdi-autorenew mdi v-icon text-lg ml-1"></i>',
    },
    id: portalOutdatedNotificationId,
  };
  notify(newParams);
}
